import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Loading from 'components/LoadingComponent';
import SwipeableCards from 'components/Steps/SwipeableCards';
import { getRecommendedTables } from 'modules/think-seeds/actions';
import NoUserInfoImg from 'assets/images/think/no_think_chats.svg';
import { LoadingWrapper, FeedbackWrapper, NoElements } from './styles';


function RecommendationsTables(props) {
  const {
    app, resetAll, setBreadcrumb, literals,
  } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [recommendedTablesIds, setRecommendedTablesIds] = useState([]);
  const [isTheEnd, setIsTheEnd] = useState(false);

  const initBreadcrumb = () => {
    const breadcrumb = [
      {
        type: 'back',
      },
      {
        color: '#ffffff',
        text: literals.serendipity,
      },
    ];

    setBreadcrumb(breadcrumb.slice());
  };

  const loadRecommendations = () => {
    getRecommendedTables()
      .then((response) => {
        setIsLoading(false);
        setRecommendedTablesIds(response);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const handleEnd = () => {
    setIsTheEnd(true);
  };

  useEffect(() => {
    initBreadcrumb();
    resetAll();
    loadRecommendations();
  }, []);

  if (isLoading) {
    return (
      <LoadingWrapper>
        <Loading colorAnimation={app.color1} />
      </LoadingWrapper>
    );
  }

  if (isTheEnd || !recommendedTablesIds.length) {
    return (
      <FeedbackWrapper>
        <div className='title' dangerouslySetInnerHTML={{ __html: literals.descriptionUsers }} />
        <NoElements>
          <div className='nocontent'>
            <img src={NoUserInfoImg} alt='' />
            <div className='text'>{literals.noTables}</div>
          </div>
        </NoElements>
      </FeedbackWrapper>
    );
  }

  return (
    <div>
      <FeedbackWrapper>
        <div className='title' dangerouslySetInnerHTML={{ __html: literals.descriptionTables }} />
        <SwipeableCards
          thinkSeeds={recommendedTablesIds}
          hideFirst
          onEnd={handleEnd}
        />
      </FeedbackWrapper>
    </div>
  );
}

RecommendationsTables.propTypes = {
  app: PropTypes.object.isRequired,
  literals: PropTypes.object.isRequired,
  resetAll: PropTypes.func.isRequired,
  setBreadcrumb: PropTypes.func.isRequired,
};

export default RecommendationsTables;



// WEBPACK FOOTER //
// ./src/routes/RecommendationsTables/components/index.jsx